// combatpro/panels/CombatLogPanel.js
//
// Combat PRO - CombatLogPanel (Stage 16 render layer; Stage 96 faithful entry
// render). The Stage 9 static shell and Stage 16 context read are preserved. Stage
// 96 completes the previously deferred entry render to match the legacy
// updateCombatLogDisplay (battletracker.html 8525-8538):
//   - each entry renders <div class="log-entry {type}"><strong>Round {round}</strong>
//     - {timestamp}<br>{message}</div>, newest-first (the store is unshift-ordered
//     by addCombatLog).
//   - empty state preserved exactly ("Combat log is empty. Actions will appear
//     here.").
//   - message is legacy-built HTML (<strong>/<em>/<span>); the legacy renderer used
//     innerHTML, so the faithful React equivalent renders the message via
//     dangerouslySetInnerHTML for the message text ONLY. The message is engine-
//     generated (addCombatLog call sites), never user input.
//   - the Clear button is wired to the clearCombatLog runtime (legacy 9190); the
//     close button remains inert (panel toggle is owned by CombatProEngineApp).
//
// CombatContext owns storage; this panel only renders. No optional chaining, no em
// dash in source.

import React, { useContext } from 'react';
import { CombatContext } from '../contexts/CombatContext';

function CombatLogPanel({ isOpen, onClose }) {
  const { state, clearCombatLog } = useContext(CombatContext);
  const combatLogEntries = state.combatLogEntries;

  return (
    <div className={isOpen ? 'combat-log open' : 'combat-log'} id="combatLog">
      <div className="combat-log-header">
        <span>⚔️ Combat Log</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <button className="vi-btn vi-btn-xs" onClick={clearCombatLog}>Clear</button>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--cp-gold-bright)', cursor: 'pointer', fontSize: '16px', padding: '0 4px', lineHeight: '1' }}>✕</button>
        </span>
      </div>
      <div className="combat-log-content" id="combatLogContent">
        {combatLogEntries.length === 0 ? (
          <div className="vi-empty">Combat log is empty.<br />Actions will appear here.</div>
        ) : (
          combatLogEntries.map((entry, index) => (
            <div className={'log-entry ' + entry.type} key={index}>
              <strong>Round {entry.round}</strong> - {entry.timestamp}<br />
              <span dangerouslySetInnerHTML={{ __html: entry.message }} />
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default CombatLogPanel;
